import { type ComponentProps, type ReactElement } from "react";
import { Navigate, useLocation } from "react-router-dom";

type NavigateWithSearchProps = ComponentProps<typeof Navigate>;

export const NavigateWithSearch = ({ to, ...rest }: NavigateWithSearchProps): ReactElement => {
    const { search } = useLocation();
    const pathname = typeof to === "string" ? to : to.pathname;

    return <Navigate to={{ pathname, search }} {...rest} />;
};
